export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20digital%20news%20platform%20abstract%20illustration%20with%20connected%20nodes%20and%20data%20flow%20elements%2C%20warm%20coral%20and%20amber%20gradient%2C%20futuristic%20yet%20minimal%20design%2C%20clean%20geometric%20composition%2C%20tech%20media%20aesthetic&width=600&height=400&seq=about-visual-01&orientation=landscape"
              alt="关于51吃瓜网址 - 娱乐资讯聚合平台"
              className="w-full h-auto object-cover rounded-lg"
              width="600"
              height="400"
            />
          </div>
          <div className="flex-1 w-full">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              51吃瓜网址是一个专注于娱乐资讯聚合与分发的综合平台。我们致力于为广大吃瓜群众提供最新、最全、最有趣的娱乐八卦和热点资讯。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台聚合了全网100+优质信息源，通过智能算法与人工精选相结合的方式，确保每一条内容都经过严格筛选。无论是明星动态、综艺热点、影视资讯还是网络热议话题，你都能在这里找到最全面的梳理和最有趣的解读。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              为了满足不同设备和场景的使用需求，我们推出了51吃瓜app、51吃瓜轻量版以及51吃瓜网app三个版本，全面支持安卓下载和苹果版客户端。无论你使用的是旗舰机还是入门机，都能找到最适合自己的吃瓜方式。
            </p>
            <div className="flex flex-wrap gap-6">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-black text-primary-500">3+</p>
                <p className="text-xs text-foreground-400 mt-1">客户端版本</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-black text-accent-500">100+</p>
                <p className="text-xs text-foreground-400 mt-1">内容信息源</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-black text-primary-500">50+</p>
                <p className="text-xs text-foreground-400 mt-1">日更新话题</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-black text-accent-500">千万级</p>
                <p className="text-xs text-foreground-400 mt-1">活跃用户</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}